export const StepperActive = () => (
  <svg width="36" height="40" viewBox="0 0 36 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g filter="url(#filter0_dd_226_12085)">
      <rect x="4" y="6" width="28" height="28" rx="14" fill="white" />
      <circle cx="18" cy="20" r="5" fill="#175CE5" />
    </g>
    <defs>
      <filter
        id="filter0_dd_226_12085"
        x="0"
        y="0"
        width="36"
        height="40"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
        <feOffset dy="2" />
        <feGaussianBlur stdDeviation="2" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
        <feBlend mode="multiply" in2="BackgroundImageFix" result="effect1_dropShadow_226_12085" />
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
        <feOffset dy="-2" />
        <feGaussianBlur stdDeviation="2" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0" />
        <feBlend mode="normal" in2="effect1_dropShadow_226_12085" result="effect2_dropShadow_226_12085" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_226_12085" result="shape" />
      </filter>
    </defs>
  </svg>
);
